import React, { useState } from 'react';
import { FadeInSection, CTAButton } from './ui';
import { Check, Gift, ShieldAlert, AlertCircle, ChevronDown, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function LegalModal({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-21">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-23">
          <div className="flex items-center justify-between p-6 border-b border-brand-creamDark" data-id="element-24">
            <h3 className="text-xl font-playfair font-bold text-brand-brown" data-id="element-25">
              {title}
            </h3>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-brand-cream transition-colors text-brand-brown/60 hover:text-brand-brown" data-id="element-26">
              <X size={20} data-id="element-27" />
            </button>
          </div>
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-brand-brown/80 text-sm leading-relaxed space-y-4" data-id="element-28">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export const Offer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="bg-brand-cream" data-id="element-29">
      {/* SECCIÓN 10: STACK DE OFERTA */}
      <section className="py-24 px-4 max-w-4xl mx-auto" data-id="element-30">
        <FadeInSection data-id="element-31">
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-brand-copper/30 overflow-hidden" data-id="element-32">
            <div className="bg-brand-brown text-center py-8 px-4" data-id="element-33">
              <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brand-copperLight mb-2" data-id="element-34">
                Todo lo que recibes hoy
              </h2>
              <p className="text-brand-cream/80" data-id="element-35">
                Acceso inmediato y de por vida
              </p>
            </div>

            <div className="p-8 md:p-12 space-y-6" data-id="element-36">
              {[{
              icon: <Check className="text-green-600" data-id="element-37" />,
              text: 'eBook S.O.S. Rescate Capilar Post-Químicos (6 capítulos completos)',
              bold: 'El sistema completo'
            }, {
              icon: <Check className="text-green-600" data-id="element-38" />,
              text: 'Guía de Diagnóstico: Escala de Daño 1-5',
              bold: 'Tu punto de partida personalizado'
            }, {
              icon: <Check className="text-green-600" data-id="element-39" />,
              text: 'Rutina Diaria de 7 Días — qué hacer exactamente cada día',
              bold: 'Tu hoja de ruta diaria'
            }, {
              icon: <Gift className="text-brand-red" data-id="element-40" />,
              text: 'BONO: Mini-guía de Peinados Protectores',
              bold: 'Cuídate mientras te recuperas'
            }, {
              icon: <Gift className="text-brand-red" data-id="element-41" />,
              text: 'BONO: Tabla de Productos Económicos vs. Premium',
              bold: 'Compra inteligente, sin gastar de más'
            }].map((item, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-brand-cream/50 border border-brand-creamDark" data-id="element-42">
                  <div className="mt-1 bg-white rounded-full p-1 shadow-sm" data-id="element-43">
                    {item.icon}
                  </div>
                  <div data-id="element-44">
                    <p className="font-medium text-brand-brown" data-id="element-45">{item.text}</p>
                    <p className="text-sm text-brand-copper font-bold mt-1" data-id="element-46">
                      {item.bold}
                    </p>
                  </div>
                </div>)}
            </div>

            {/* SECCIÓN 11: INVERSIÓN & GARANTÍA */}
            <div className="bg-brand-creamDark/30 p-8 md:p-12 border-t border-brand-creamDark text-center" data-id="element-47">
              <p className="text-brand-brown/70 mb-6 max-w-2xl mx-auto" data-id="element-48">
                Una sola sesión de reconstrucción en salón puede costarte entre
                $50 y $200 USD. Sin garantía. Sin que te enseñen qué hacer en
                casa. Sin protocolo para mantener el resultado.
              </p>

              <p className="text-xl font-bold text-brand-brown mb-8" data-id="element-49">
                S.O.S. Rescate Capilar te da el sistema completo para hacerlo tú
                misma.
              </p>

              <div className="mb-8" id="comprar" data-id="element-50">
                <div className="inline-flex items-center gap-3 bg-brand-copper/10 px-6 py-3 rounded-full mb-4" data-id="element-51">
                  <span className="text-brand-brown/50 line-through text-xl" data-id="element-52">
                    $19.97
                  </span>
                  <span className="bg-brand-red text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-53">
                    -68%
                  </span>
                </div>
                <p className="text-5xl md:text-6xl font-playfair font-bold text-brand-brown" data-id="element-54">
                  $6<span className="text-3xl md:text-4xl" data-id="element-55">.39</span>{' '}
                  <span className="text-lg font-sans text-brand-brown/60 font-normal" data-id="element-56">
                    USD
                  </span>
                </p>
                <p className="text-sm text-brand-brown/60 mt-2" data-id="element-57">
                  Pago único — acceso de por vida
                </p>
              </div>

              <CTAButton text="SÍ, QUIERO RESCATAR MI CABELLO AHORA" className="w-full md:w-auto text-xl py-5 px-10" data-id="element-58" />

              <div className="mt-12 bg-white p-6 rounded-2xl border border-brand-copper/20 flex flex-col md:flex-row items-center gap-6 text-left shadow-sm" data-id="element-59">
                <ShieldAlert className="w-16 h-16 text-brand-copper shrink-0" data-id="element-60" />
                <div data-id="element-61">
                  <h4 className="text-xl font-playfair font-bold text-brand-brown mb-2" data-id="element-62">
                    GARANTÍA TOTAL 7 DÍAS
                  </h4>
                  <p className="text-brand-brown/80 text-sm leading-relaxed" data-id="element-63">
                    Si sigues el protocolo de 7 días y no ves ninguna mejora en
                    tu cabello, te devolvemos tu inversión — sin preguntas, sin
                    formularios complicados, sin drama. Así de seguras estamos
                    de que esto funciona. El único riesgo aquí es seguir
                    esperando.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>
      </section>

      {/* SECCIÓN 12: URGENCIA */}
      <section className="py-16 px-4 bg-brand-red text-white text-center" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <FadeInSection data-id="element-66">
            <AlertCircle className="w-12 h-12 mx-auto mb-6 opacity-80" data-id="element-67" />
            <p className="text-xl md:text-2xl font-playfair leading-relaxed mb-8" data-id="element-68">
              Cada día que tu cabello chicloso sigue sin el protocolo correcto
              es un día que la fibra capilar sigue debilitándose.
            </p>
            <p className="text-white/80 mb-8" data-id="element-69">
              El daño post-químico no se "estabiliza" solo. Progresa. Y cada
              lavado mal ejecutado, cada peinada sin protección, cada mascarilla
              aplicada sin estructura — acerca tu cabello un paso más al punto
              de no retorno.
            </p>
            <p className="text-2xl md:text-3xl font-bold font-playfair text-brand-cream" data-id="element-70">
              7 días es todo lo que separa tu cabello de hoy del cabello que
              quieres tener.
              <br data-id="element-71" />
              <span className="italic mt-4 block text-xl" data-id="element-72">
                ¿Cuántos días más vas a esperar?
              </span>
            </p>
          </FadeInSection>
        </div>
      </section>

      {/* SECCIÓN 13: LLAMADA A LA ACCIÓN FINAL */}
      <section className="py-24 px-4 text-center" data-id="element-73">
        <FadeInSection data-id="element-74">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-brand-brown mb-8" data-id="element-75">
            Tu cabello no necesita un salón.
            <br data-id="element-76" />
            <span className="text-brand-copper" data-id="element-77">
              Necesita el sistema correcto.
            </span>
          </h2>
          <p className="text-2xl font-playfair italic text-brand-brown/80 mb-12" data-id="element-78">
            Y tú lo mereces.
          </p>

          <CTAButton text="OBTENER ACCESO INMEDIATO" className="text-xl py-5 px-12" data-id="element-79" />
        </FadeInSection>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-80">
        <FadeInSection data-id="element-81">
          <h2 className="text-3xl font-playfair font-bold text-center text-brand-brown mb-12" data-id="element-82">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-83">
            {[{
            q: '¿Funciona para todo tipo de cabello?',
            a: 'El protocolo está diseñado para cabello dañado por procesos químicos — tintes, decoloraciones, alisados, permanentes. Incluye diagnóstico por niveles de daño para que puedas adaptarlo exactamente a tu situación.'
          }, {
            q: '¿Y si mi daño es muy severo?',
            a: 'El Capítulo 1 incluye una Escala de Daño del 1 al 5. El protocolo tiene indicaciones específicas para cada nivel — incluyendo daño severo.'
          }, {
            q: '¿Necesito productos caros?',
            a: 'No. El Capítulo 4 y el Bono de Tabla de Productos están diseñados específicamente para usar lo que se consigue en supermercado o farmacia en cualquier país de Latinoamérica.'
          }, {
            q: '¿En verdad se ven resultados en 7 días?',
            a: 'Sí — cuando el protocolo se aplica en el orden correcto. Los primeros cambios (textura, menos quiebre) se empiezan a notar desde el Día 3. El resultado completo se evalúa el Día 7, con instrucciones de ajuste si se necesita.'
          }, {
            q: '¿Tengo que hacer todo exactamente igual?',
            a: 'Cada día tiene instrucciones claras y específicas. No hay lugar para adivinar. Sigues la guía, y la guía te lleva a los resultados.'
          }, {
            q: '¿Qué pasa si no funciona?',
            a: 'Aplica la garantía de devolución total. Sin preguntas. Si seguiste el protocolo y no ves ninguna mejora, recuperas tu inversión completa.'
          }, {
            q: '¿Es un eBook o es un curso?',
            a: 'Es un eBook en PDF — descarga inmediata, acceso desde cualquier dispositivo, sin suscripciones ni plataformas extras. Lo tienes para siempre.'
          }].map((faq, i) => <details key={i} className="group bg-white rounded-xl border border-brand-creamDark overflow-hidden" data-id="element-84">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none p-6 text-brand-brown hover:bg-brand-cream transition-colors" data-id="element-85">
                  <span data-id="element-86">{faq.q}</span>
                  <span className="transition group-open:rotate-180" data-id="element-87">
                    <ChevronDown size={20} className="text-brand-copper" data-id="element-88" />
                  </span>
                </summary>
                <div className="text-brand-brown/70 p-6 pt-0 leading-relaxed border-t border-brand-creamDark/50 mt-2" data-id="element-89">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </FadeInSection>
      </section>

      {/* FOOTER */}
      <footer className="bg-brand-brown text-brand-cream py-16 px-4 text-center border-t-4 border-brand-copper" data-id="element-90">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-91">
          <div className="space-y-4 font-playfair italic text-brand-copperLight text-lg md:text-xl" data-id="element-92">
            <p data-id="element-93">
              "El cabello chicloso no es el problema. El orden equivocado de los
              tratamientos es el problema."
            </p>
            <p data-id="element-94">
              "No es que tu cabello no tenga solución. Es que nadie te dio el
              mapa."
            </p>
            <p data-id="element-95">"No cortes lo que todavía puede salvarse."</p>
          </div>

          <div className="pt-8 border-t border-brand-cream/10 text-sm text-brand-cream/50 space-y-3" data-id="element-96">
            <div className="flex items-center justify-center gap-4" data-id="element-97">
              <button onClick={() => setShowTerms(true)} className="underline hover:text-brand-copperLight transition-colors cursor-pointer" data-id="element-98">
                Términos y Condiciones
              </button>
              <span className="opacity-30" data-id="element-99">|</span>
              <button onClick={() => setShowPrivacy(true)} className="underline hover:text-brand-copperLight transition-colors cursor-pointer" data-id="element-100">
                Política de Privacidad
              </button>
            </div>
            <p data-id="element-101">
              © {new Date().getFullYear()} S.O.S. Rescate Capilar
              Post-Químicos. Todos los derechos reservados.
            </p>
            <p data-id="element-102">
              Este sitio no es parte del sitio web de Facebook o Meta Inc.
              Además, este sitio NO está respaldado por Facebook de ninguna
              manera.
            </p>
          </div>
        </div>
      </footer>

      {showTerms && <LegalModal title="Términos y Condiciones" onClose={() => setShowTerms(false)} data-id="element-103">
          <p className="font-bold" data-id="element-104">Última actualización: Marzo 2026</p>
          <p data-id="element-105">
            Al acceder y utilizar este sitio web y adquirir el producto digital
            "S.O.S. Rescate Capilar Post-Químicos", aceptas los siguientes
            términos y condiciones.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-106">
            1. Producto Digital
          </h4>
          <p data-id="element-107">
            El producto ofrecido es un eBook en formato PDF de descarga digital.
            Una vez completada la compra, recibirás acceso inmediato al
            contenido. Este producto es para uso personal y no puede ser
            redistribuido, revendido ni compartido sin autorización expresa.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-108">
            2. Uso del Contenido
          </h4>
          <p data-id="element-109">
            Todo el contenido del eBook, incluyendo textos, gráficos, tablas y
            protocolos, está protegido por derechos de autor. Queda prohibida su
            reproducción total o parcial sin consentimiento previo por escrito.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-110">3. Resultados</h4>
          <p data-id="element-111">
            Los resultados descritos en este sitio y en el producto son
            orientativos y pueden variar según el tipo de cabello, nivel de daño
            y adherencia al protocolo. No garantizamos resultados específicos.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-112">
            4. Política de Reembolso
          </h4>
          <p data-id="element-113">
            Ofrecemos una garantía de devolución de 7 días desde la fecha de
            compra. Si seguiste el protocolo completo y no observaste ninguna
            mejora, puedes solicitar un reembolso total a través de la
            plataforma de pago (Hotmart).
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-114">
            5. Descargo de Responsabilidad
          </h4>
          <p data-id="element-115">
            Este producto tiene fines informativos y educativos. No sustituye el
            consejo de un profesional de la salud capilar o dermatólogo. Si
            tienes condiciones médicas del cuero cabelludo, consulta a un
            especialista antes de seguir cualquier protocolo.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-116">6. Modificaciones</h4>
          <p data-id="element-117">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones serán efectivas a partir de su
            publicación en este sitio.
          </p>
        </LegalModal>}

      {showPrivacy && <LegalModal title="Política de Privacidad" onClose={() => setShowPrivacy(false)} data-id="element-118">
          <p className="font-bold" data-id="element-119">Última actualización: Marzo 2026</p>
          <p data-id="element-120">
            Tu privacidad es importante para nosotros. Esta política describe
            cómo recopilamos, usamos y protegemos tu información personal.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-121">
            1. Información que Recopilamos
          </h4>
          <p data-id="element-122">
            Al realizar una compra, la plataforma de pago (Hotmart) puede
            recopilar tu nombre, correo electrónico y datos de pago. Nosotros no
            almacenamos directamente información de tarjetas de crédito ni datos
            financieros.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-123">
            2. Uso de la Información
          </h4>
          <p data-id="element-124">
            La información recopilada se utiliza exclusivamente para: procesar
            tu compra y entregarte el producto digital, enviarte comunicaciones
            relacionadas con tu compra, y mejorar nuestros productos y
            servicios.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-125">
            3. Protección de Datos
          </h4>
          <p data-id="element-126">
            Implementamos medidas de seguridad razonables para proteger tu
            información personal contra acceso no autorizado, alteración o
            destrucción.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-127">
            4. Cookies y Tecnologías de Seguimiento
          </h4>
          <p data-id="element-128">
            Este sitio puede utilizar cookies y píxeles de seguimiento con fines
            analíticos y publicitarios. Puedes configurar tu navegador para
            rechazar cookies, aunque esto podría afectar la funcionalidad del
            sitio.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-129">5. Terceros</h4>
          <p data-id="element-130">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto a los proveedores de servicios necesarios para
            procesar tu compra (como Hotmart).
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-131">6. Tus Derechos</h4>
          <p data-id="element-132">
            Tienes derecho a acceder, rectificar o eliminar tu información
            personal. Para ejercer estos derechos, puedes contactarnos a través
            de la plataforma de venta.
          </p>
          <h4 className="font-bold text-brand-brown mt-4" data-id="element-133">
            7. Cambios en esta Política
          </h4>
          <p data-id="element-134">
            Nos reservamos el derecho de actualizar esta política en cualquier
            momento. Te notificaremos de cambios significativos a través de
            nuestro sitio web.
          </p>
        </LegalModal>}
    </div>;
};